import styled from 'styled-components';

export const SimpleText = styled.div`
font-family: "Cinzel", serif;
font-size: 1.25em;
color: white;
text-align: center;
margin-top: 0.25em;

@media only screen and (max-width: 500px) {
  font-size: 1.125em;
}

@media only screen and (max-width: 375px) {
  font-size: 0.75em;
}
`;

export const ParticipantContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  min-width: 15%;
  min-height: 100%;
  padding-left: 2em;
  padding-right: 2em;
  padding-bottom: 2em;

  @media only screen and (max-width: 520px) {
    font-size: 0.75em;
  }
`;

export const Participant = styled.h4`
  color: white;
  margin-bottom: 0.25em;
`;